import { SIZE } from '../../../constants/size'
import { FormModal, formValidationSchemaNoChanged } from '../../Form'

import { FormFields } from './FormFields'
import { FIELD_ADDRESS_NAME, QA_NAME_MAP } from './GoogleMapModal.constants'

import * as styles from './GoogleMapModal.module.css'

function GoogleMapModal({
  addressSelectProps,
  buttonText,
  editMode,
  formBodyProps,
  initialValues,
  title,
  onClose,
  onSubmit,
}) {
  // In view mode the submit button just closes the modal, so the
  // "no changes" schema must not block it
  const validationSchema = editMode
    ? formValidationSchemaNoChanged({ initialValues })
    : null

  function handleSubmitForm({ values }) {
    onSubmit(values[FIELD_ADDRESS_NAME])
  }

  return (
    <FormModal
      Fields={FormFields}
      containerProps={{
        boxSize: SIZE.LARGE,
        qaName: QA_NAME_MAP,
      }}
      formBodyProps={{
        ...formBodyProps,
        contentClassName: styles.content,
        submitButtonText: buttonText,
        withNotifications: true,
      }}
      formFieldsProps={{ addressSelectProps, editMode }}
      formTitle={title}
      initialValues={initialValues}
      validationSchema={validationSchema}
      onClose={onClose}
      onSubmit={handleSubmitForm}
    />
  )
}

export default GoogleMapModal
